<template>

  <main class="content">
    <!-- content -->
    <section class="intro">
      <div class='container'>

        <div class="intro__wrapper">
          <div class="intro__text text-intro">
            <h1 class="text-intro__title">ВЫИГРАЙТЕ СВОЕ ДЕЛО БЕЗ ОБРАЩЕНИЯ К ЮРИСТАМ!</h1>
            <p class="text-intro__subtitle">Хочешь сделать хорошо? Сделай сам!</p>
            <a @click="$root.requestModal = 1, $root.modalText = '<iframe src=\'https://www.youtube.com/embed/0picNrwktUs\'></iframe>'" class="intro__link">
              <picture><source srcset="/static/img/intro/play.svg" type="image/webp"><img src="/static/img/intro/play.svg" alt="" /></picture>
              <span>Как это происходит?</span>
            </a>
          </div>
          <div class="intro__image">
            <picture><source srcset="/static/img/intro/vector.svg" type="image/webp"><img src="/static/img/intro/vector.svg" alt="" /></picture>
          </div>
        </div>
      </div>
    </section>

    <section class="risk">
      <div class='container'>
        <div class="risk__wraper">
          <div class="risk__column">
            <ul class="risk__list">
              <router-link :to="'/groups/' + group.id" class="risk__link" v-for="group in categories" :key="group.id">{{group.name}}
                  <picture>
                    <source srcset="/static/img/risk/Arrow.svg" type="image/webp"><img src="/static/img/risk/Arrow.svg" alt="" />
                  </picture>
              </router-link>
            </ul>
          </div>
          <div class="risk__items items-risk">
            <div class="risk__item">
              <div class="risk__picture">
                <picture><source srcset="/static/img/risk/1.svg" type="image/webp"><img src="/static/img/risk/1.svg" alt="" /></picture>
              </div>
              <div class="risk__text">Получаете комплект необходимых документов чтобы выиграть свое дело. Готовите их по нашим шаблонам или доверяете подготовку нам.</div>
            </div>
            <div class="risk__item">
              <div class="risk__picture">
                <picture><source srcset="/static/img/risk/2.svg" type="image/webp"><img src="/static/img/risk/2.svg" alt="" /></picture>
              </div>
              <div class="risk__text">У вас будет чёткая инструкция действий. Идете с этими документами в суд или решаете в досудебном порядке</div>
            </div>
            <div class="risk__item">
              <div class="risk__picture">
                <picture><source srcset="/static/img/risk/3.svg" type="image/webp"><img src="/static/img/risk/3.svg" alt="" /></picture>
              </div>
              <div class="risk__text">Выигрываете дело. Без рисков, без затрат на юристов.</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="info">
      <div class='container'>
        <div class="info__wrapper">
          <h2 class="info__title">Как выигрываются дела</h2>
          <div class="info__inner">
            <div class="swiper-container">
              <!-- Additional required wrapper -->
              <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide">
                  <div class="info__item">
                    <div class="info__number"><span>1</span></div>
                    <div class="info__text">
                      <p>
                        Главные аргументы, позволяющие выиграть дело – доказательства. Доказательства - это документы, которые подаются в суд или используются для досудебного решения вопроса – на их основании будет выноситься решение. Да! Это юридически грамотные документы, а не слова.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="info__item">
                    <div class="info__number"><span>2</span></div>
                    <div class="info__text">
                      <p>
                        Вам не нужно быть юристом и разбираться во всем. Вы научитесь разбираться в  конкретном юридическом вопросе благодаря шаблонам, образцам, памяткам, понятным инструкциям. Разберитесь с решением  вопроса максимум за 2 часа.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="info__item">
                    <div class="info__number"><span>3</span></div>
                    <div class="info__text">
                      <p>
                        Наши юристы уже все сделали за Вас. Потратьте немного времени, заполнить шаблоны конкретно по своей ситуации и выиграть свое дело!
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="black black-margin">
      <div class='container'>
        <div class="black__wrapper">
          <div class="black__inner inner-black">
            <h1 class="inner-black__text">Как и почему с нашими документами выигрываются дела?</h1>
            <p class="inner-black__subtext">
              Вы не знаете законов, не знаете своих прав, не знаете какие юридические ошибки могут быть совершены.
              Поэтому мы все уже сделали за вас и сделали это правильно!
              Главное - это не то, что говорите в суде, а доказательства.
              У нас обобщено 22407 дел на 3 квартал 2021 года и каждый день в базу добавляются новые дела.
            </p>
            <div class="black__white white-black">
              <h1 class="white-black__text">299 руб за все документы для того, чтобы вы выиграли свое дело. Плюс, пошаговая инструкция: как выиграть дело в суде.</h1>
              <ol class="white-black__list">
                <li class="white-black__link">Никаких сомнительных юристов, берущих деньги за «воздух»</li>
                <li class="white-black__link">Проверенные, актуальные на сегодняшний день решения из всех областей права</li>
                <li class="white-black__link">Сотни людей и организаций ежедневно решают свои проблемы при помощи нашего сервиса и рекомендуют нас своим друзьям и знакомым</li>
              </ol>
              <div class="black__btn-wrapper">
                <a href="#formSelect" class="black__btn">Получить документы</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="document">
      <div class='container'>
        <div class="document__wrapper">
          <div class="document__inner">
            <div class="document__list list-document">
                <h1 class="document__title">Для кого</h1>
              <ul class="list-document__ul">
                <li class="list-document__link">Для тех, кому предстоит суд по любой возникшей проблеме</li>
                <li class="list-document__link">Для тех, кто хочет решить вопрос в досудебном порядке</li>
                <li class="list-document__link">Для тех, кто сомневается в качестве работы своего юриста или просто хочет проверить его работу</li>
                <li class="list-document__link">Для начинающих юристов, помощников юристов и студентов</li>
              </ul>
            </div>
            <div class="document__form form-document">
              <div id="formSelect">
                <div class="form-document__wrapper">
                  <div class="form-document__select-box" style="flex: 0 1 100%;margin-right: 0;">
                    <div :class="selectCategory.show?'nice-select select-block open':'nice-select select-block'" @click="selectCategory.show=1" @focusout="selectCategory.show=0" tabindex="0">
                      <span class="current">{{selectCategory.name?selectCategory.name:'Выберите категорию'}}</span>
                      <ul class="list">
                        <li v-for="group in categories" :key="group.id" :class="selectCategory.id===group.id?'option selected focus':'option'" @click="selectCategory.id = group.id, selectCategory.name = group.name">
                          {{group.name}}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-document__select-box" style="flex: 0 1 100%;margin-right: 0;" v-show="parseInt(selectCategory.id)">
                    <div :class="selectGroup.show?'nice-select select-block open':'nice-select select-block'" @click="selectGroup.show=1" @focusout="selectGroup.show=0" tabindex="0">
                      <span class="current">{{selectGroup.name?selectGroup.name:'Выберите группу'}}</span>
                      <ul class="list" v-if="549 === parseInt(selectCategory.id)">
                        <li v-for="group in groupsAA" :key="group.id" :class="selectGroup.id===group.id?'option selected focus':'option'" @click="selectGroup.id = group.id, selectGroup.name = group.name">
                          {{group.name}}</li>
                      </ul>
                      <ul class="list" v-else>
                        <li v-for="group in groupsBEZ" :key="group.id" :class="selectGroup.id===group.id?'option selected focus':'option'" @click="selectGroup.id = group.id, selectGroup.name = group.name"  v-if="parseInt(group.cf[532]) === parseInt(selectCategory.id)">
                          {{group.name}}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-document__select-box" style="flex: 0 1 100%;margin-right: 0;" v-show="parseInt(selectGroup.id)">
                    <div :class="selectService.show?'nice-select select-block open':'nice-select select-block'" @click="selectService.show=1" @focusout="selectService.show=0" tabindex="0">
                      <span class="current">{{selectService.name?selectService.name:'Выберите статью'}}</span>
                      <ul class="list" v-if="549 === parseInt(selectCategory.id)">
                        <li v-for="service in servicesAA" :key="service.id" :class="selectService.id===service.id?'option selected focus':'option'"  v-if="parseInt(service.cf[341]) === parseInt(selectGroup.id)" @click="selectService.id = service.id, selectService.name = service.name">
                          {{service.name}}</li>
                      </ul>
                      <ul class="list" v-else>
                        <li v-for="service in servicesBEZ" :key="service.id" :class="selectService.id===service.id?'option selected focus':'option'"  v-if="parseInt(service.cf[495]) === parseInt(selectGroup.id)" @click="selectService.id = service.id, selectService.name = service.name">
                          {{service.name}}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-document__select-box box-input-margin">
                    <input autocomplete="off" type="text" name="form[]" class="form-document__input" placeholder="Город" v-model="city"/>
                  </div>
                  <div class="form-document__input-box">
                    <input autocomplete="off" type="text" name="form[]" class="form-document__input" placeholder="Имя" v-model="name"/>
                  </div>
                  <div class="form-document__input-box box-input-margin">
                    <input autocomplete="off" type="tel" name="form[]" class="form-document__input" placeholder="Телефон" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                  </div>
                  <div class="form-document__input-box">
                    <input autocomplete="off" type="email" name="form[]" class="form-document__input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
                  </div>
                  <div class="form-document__btn-wrapper">
                    <button class="form-document__btn" @click="sendQuestion">Получить документы</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>

</template>

<script>
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
  name: 'HelloWorld',
  data () {
    return {
      categories: [],
      groupsAA: [],
      servicesAA: [],
      groupsBEZ: [],
      servicesBEZ: [],
      selectCategory: {id: null, show: 0, name: null},
      selectGroup: {id: null, show: 0, name: null},
      selectService: {id: null, show: 0, name: null},
      name: null,
      email: null,
      phone: null,
      city: null,
      price: null
    }
  },
  mounted () {
    Inputmask().mask(document.querySelectorAll('input'))
    setTimeout(() => {
      Inputmask().mask(document.querySelectorAll('input'))
    }, 1000)
    axios.get('https://bez.v-avtoservice.com/list/get-lists?id=38').then(response => {
      this.categories = response.data
    })
    axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=31').then(response => {
      this.groupsAA = response.data
    })
    axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=32').then(response => {
      this.servicesAA = response.data
    })
    axios.get('https://bez.v-avtoservice.com/list/get-lists?id=40').then(response => {
      this.groupsBEZ = response.data
    })
    axios.get('https://bez.v-avtoservice.com/list/get-lists?id=39').then(response => {
      this.servicesBEZ = response.data
    })
    $(document).on('click.accordion', '.item-accordion__header', function () {
      var parent = $(this).parent()
      if (parent.hasClass('active')) {
        parent.removeClass('active')
      } else {
        $('.accordion__item').removeClass('active')
        parent.addClass('active')
      }
    })
    setTimeout(() => {
    // eslint-disable-next-line
    new Swiper('.swiper-container', {
      loop: false,
      observer: true,
      observeParents: true,
      slidesPerView: 3,
      spaceBetween: 0,
      speed: 800,
      breakpoints: {
        320: {
          slidesPerView: 'auto',
          spaceBetween: 0
        },
        376: {
          slidesPerView: 1
        },
        767: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        },
        1292: {
          slidesPerView: 3
        }
      }
    })
    }, 1000)
  },
  beforeDestroy () {
    $(document).unbind('click.accordion')
  },
  methods: {
    showModal () {
      this.$root.requestModal = 1
    },
    sendQuestion () {
      if (!this.email) alert('Вам необходимо указать E-mail')
      if (!this.phone) alert('Вам необходимо указать телефон')
      else if (!this.selectCategory.name) alert('Вам необходимо выбрать категорию')
      else if (!this.selectGroup.name) alert('Вам необходимо выбрать группу')
      else if (!this.selectService.name) alert('Вам необходимо выбрать статью')
      else {
        if (this.selectService.name.toLowerCase().indexOf('ходатайства') >= 0) {
          this.price = 0
        } else this.price = 299
        if (parseInt(this.selectCategory.id) === 549) {
          var formData = new FormData()
          formData.append('crm', '9')
          formData.append('pipe', '17')
          formData.append('contact[name]', this.name)
          formData.append('contact[141]', this.phone)
          formData.append('contact[142]', this.email)
          formData.append('contact[143]', this.city)
          formData.append('lead[147]', this.city)
          formData.append('lead[price]', this.price)
          formData.append('lead[146]', this.selectGroup.name)
          formData.append('lead[145]', this.selectService.name)
          axios.post('https://urist1.v-avtoservice.com/api/import-lead',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
            else alert('Спасибо, ваша заявка отправлена')
          })
        } else {
          var formDatas = new FormData()
          formDatas.append('crm', '16')
          formDatas.append('pipe', '34')
          formDatas.append('contact[name]', this.name)
          formDatas.append('contact[466]', this.phone)
          formDatas.append('contact[467]', this.email)
          formDatas.append('contact[473]', this.city)
          formDatas.append('lead[471]', this.city)
          formDatas.append('lead[price]', this.price)
          formDatas.append('lead[534]', this.selectCategory.name)
          formDatas.append('lead[468]', this.selectGroup.name)
          formDatas.append('lead[469]', this.selectService.name)
          axios.post('https://bez.v-avtoservice.com/api/import-lead',
            formDatas,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
            else alert('Спасибо, ваша заявка отправлена')
          })
        }
      }
    }
  },
  watch: {
    'selectCategory.id' (val, oldVal) {
      if (val !== oldVal) {
        setTimeout(() => {
          this.selectCategory.show = 0
          this.selectGroup = {id: null, show: 0, name: null}
        }, 100)
      }
    },
    'selectGroup.id' (val, oldVal) {
      if (val !== oldVal) {
        setTimeout(() => {
          this.selectGroup.show = 0
          this.selectService = {id: null, show: 0, name: null}
        }, 100)
      }
    },
    'selectService.id' (val, oldVal) {
      if (val !== oldVal) {
        setTimeout(() => {
          this.selectService.show = 0
        }, 100)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue